import { getCreditCard } from '@/graphql/queries/banking/credit-card';
import lang from '@/lang/middleware/products/banking/credit-cards';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  await $apolloQuery(getCreditCard, { code: route.params.code }).then(card => {
    if ((route.params.slug !== card.slug) || (route.params.provider !== card.institution.slug)) {
      return redirect(301, app.localePath(`/compare-credit-cards/${card.institution.slug}/${card.code}/${card.slug}/`));
    }

    let starCount = 0;
    let tacs = '';

    store.$i18n.mergeLocaleMessage('en', lang.en);

    const list = ['purchases_intro', 'bt', 'comparison'].map(key => {
      const apr = card[`${key}_apr`];
      if (typeof apr === 'number') {
        const pct = store.$i18n.n(apr / 100, 'percent');
        if (key === 'comparison') {
          return store.$i18n.t('results.jumbotron.list.comparison', [pct]);
        }
        const duration = card[`${key}_duration`];
        const stars = '*'.repeat(++starCount);
        tacs += store.$i18n.t(`results.jumbotron.tacs.${key}`, [pct, stars]);
        if (duration) {
          tacs += ' ' + store.$i18n.tc('month', [duration]);
        }
        tacs += '.  ';
        return store.$i18n.t(`results.jumbotron.list.${key}`, [pct, stars]);
      }
      return null;
    }).filter(item => item);

    const description = store.$i18n.t('results.description');
    const title = [card.institution.name, card.name].join(' ');
    store.commit('products/set', card);
    store.commit('jumbotron/SET_JUMBOTRON', { list, tacs, title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/banking', '/money/'],
      ['i18n/cards', '/compare-credit-cards/'],
      ['i18n/providers', '/compare-credit-cards/providers/'],
      [card.institution.name, `/compare-credit-cards/${card.institution.slug}/`, 'mobile'],
      card.name
    ]);
    store.commit('pageContent/setHead', { description, title });
  });
};
